module.exports = __webpack_public_path__ + "cb5b78510b3611413d6db38824a1900f.svg";